import { render, staticRenderFns } from "./proposal-card-title.vue?vue&type=template&id=377a3e23&scoped=true&"
import script from "./proposal-card-title.vue?vue&type=script&lang=js&"
export * from "./proposal-card-title.vue?vue&type=script&lang=js&"
import style0 from "./proposal-card-title.vue?vue&type=style&index=0&id=377a3e23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377a3e23",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('377a3e23')) {
      api.createRecord('377a3e23', component.options)
    } else {
      api.reload('377a3e23', component.options)
    }
    module.hot.accept("./proposal-card-title.vue?vue&type=template&id=377a3e23&scoped=true&", function () {
      api.rerender('377a3e23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/commercial/partials/proposal-card-title.vue"
export default component.exports